import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { customCell, dateCell, enumFilterCell, GridPanel, translatedCell } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../../services/api/endpoint";
import { hasPermission } from "../../../../services/authentication";
import { FollowUpTaskStatus, Permission } from "../../../../utils/enums";
import { colorCell, colorCellClassName } from "../../../global/colorCell";
import FollowUpTaskEditor, { getFollowUpTaskStatusColor } from "../../followup/followUpTask";

import style from "../../../../assets/editor.module.scss";

interface IProps {
	opportunityId: number;
}

const OpportunityFollowUpTasks: React.FC<IProps> = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<GridPanel
			className={style.tabGrid}
			listEndpoint={Endpoint.OpportunityFollowUpTasksList}
			listUrlArguments={{ opportunityId: props.opportunityId }}
			endpoint={Endpoint.OpportunityFollowUpTasks}
			addScreen={{ screen: FollowUpTaskEditor, isAllowed: hasPermission(Permission.OpportunitiesUpdate), extraProps: { opportunityId: props.opportunityId } }}
			editScreen={{ screen: FollowUpTaskEditor, isAllowed: hasPermission(Permission.OpportunitiesUpdate), extraProps: { opportunityId: props.opportunityId } }}
			delete={{ urlArguments: { opportunityId: props.opportunityId }, isAllowed: hasPermission(Permission.OpportunitiesUpdate) }}
			localLoader
		>
			<GridColumn
				field="status"
				title={t("opportunityFollowUpTaskStatus")}
				cell={customCell(colorCell(true, translatedCell(), getFollowUpTaskStatusColor), colorCellClassName)}
				filterCell={enumFilterCell(FollowUpTaskStatus)}
			/>
			<GridColumn field="creator.fullName" title={t("creator")} />
			<GridColumn field="assignee.fullName" title={t("taskAssignee")} />
			<GridColumn field="subject" title={t("subject")} />
			<GridColumn field="dueDate" title={t("dueDate")} cell={customCell(dateCell("yyyy-MM-dd HH:mm"))} filter="date" />
		</GridPanel>
	);
};

export default OpportunityFollowUpTasks;
